/**
 * @fileoverview React SMS indicator for event feed messages.
 */

import React from 'react';

import Tooltip from '../Tooltip';

const MessageSmsIndicator: React.FC = () => (
  <div className="bl-message_sms-wrapper">
    <Tooltip message="Sent with SMS" position="bottom">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="24px">
        <path
          data-name="layer2"
          d="M49.6 28.5C56.8 30.1 62 35.4 62 41.6a12.4 12.4 0 0 1-5.1 9.7L60 59l-10.3-4.3a21 21 0 0 1-4.7.5c-8.2 0-15.1-4.7-16.7-10.9"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          data-name="layer1"
          d="M4 50l15.4-6.3a29.6 29.6 0 0 0 6.6.7c13.3 0 24-8.6 24-19.2S39.3 6 26 6 2 14.6 2 25.2C2 30.6 4.8 35.5 9.3 39z"
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </Tooltip>
  </div>
);

export default MessageSmsIndicator;
